<div class="container">
    <div class="row m-0">
        <div class="col p-0">
            <app-reports-filter
                [selectedReport]="reportModel"
                [generateDisabled]="false"
                [showClassFilter]="false"
                (doFilter)="showReport($event)"
                (generateReport)="generateReportFile($event)">
            </app-reports-filter>
        </div>
    </div>
    <div *ngIf="(reportData$ | async).loaded">
        <div class="row mt-3 m-0" *ngIf="(reportData$ | async).hasItems">
            <div class="col p-0">
                <div class="row online-content-view-report-header align-items-center m-0">
                    <div class="col-1">{{ 'OnlineContentViewReport.TypeHeader' | translate }}</div>
                    <div class="col-2 text-center">{{ 'OnlineContentViewReport.ClassNameHeader' | translate }}</div>
                    <div class="col-1 text-center">{{ 'OnlineContentViewReport.ClassDateHeader' | translate }}</div>
                    <div class="col-1">{{ 'OnlineContentViewReport.TimeFromHeader' | translate }}</div>
                    <div class="col-1">{{ 'OnlineContentViewReport.TimeToHeader' | translate }}</div>
                    <div class="col-2">{{ 'OnlineContentViewReport.InstructorNameHeader' | translate }}</div>
                    <div class="col-1">{{ 'OnlineContentViewReport.MemberIdHeader' | translate }}</div>
                    <div class="col-2 text-right">{{ 'OnlineContentViewReport.MemberHeader' | translate }}</div>
                    <div class="col-1 text-center">{{ 'OnlineContentViewReport.ViewDateHeader' | translate }}</div>
                </div>
                <div class="row m-0">
                    <div class="col">
                        <app-online-content-view-report-item *ngFor="let item of (reportData$ | async).items" [item]="item">
                        </app-online-content-view-report-item>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2 m-0" *ngIf="!(reportData$ | async).hasItems "> 
            <div class="col text-center">
                <div><span class="ic-binoculars"></span></div>
                <div>{{ 'InstructorCentricReport.NoRecords' | translate }}</div>
            </div>
        </div>
    </div>
</div>